import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DetailComponents.css';

const EditTripModal = ({ trip, onSave, onClose }) => {
  const [editedTrip, setEditedTrip] = useState({
    destination: trip.destination,
    startDate: new Date(trip.startDate),
    endDate: new Date(trip.endDate),
    clientId: trip.clientId,
    bookingIds: trip.bookingIds || []
  });

  const handleSave = () => {
    if (!editedTrip.destination || !editedTrip.startDate || !editedTrip.endDate) {
      alert('Please fill in all required fields');
      return;
    }
    if (editedTrip.endDate < editedTrip.startDate) {
      alert('End Date cannot be before Start Date');
      return;
    }

    // Format dates as local strings without timezone conversion
    const formatDate = (date) => {
      if (!date) return '';
      return date.toLocaleString('en-US', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: false 
      }).replace(/,/, '');
    };

    const updatedTrip = {
      destination: editedTrip.destination,
      startDate: formatDate(editedTrip.startDate),
      endDate: formatDate(editedTrip.endDate),
      clientId: editedTrip.clientId,
      bookingIds: editedTrip.bookingIds
    };
    console.log('Saving trip:', updatedTrip);
    onSave(updatedTrip);
  };

  // Handle ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal edit-modal">
        <h3>Edit Trip</h3>
        <div className="edit-modal-form">
          <div className="edit-modal-field">
            <label className="edit-modal-label">Destination:</label>
            <input
              className="edit-modal-input"
              value={editedTrip.destination}
              onChange={e => setEditedTrip({ ...editedTrip, destination: e.target.value })}
            />
          </div>
          <div className="edit-modal-field">
            <label className="edit-modal-label">Start Date:</label>
            <DatePicker
              selected={editedTrip.startDate}
              onChange={date => setEditedTrip({ ...editedTrip, startDate: date })}
              dateFormat="MMMM d, yyyy"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              className="edit-modal-input"
            />
          </div>
          <div className="edit-modal-field">
            <label className="edit-modal-label">End Date:</label>
            <DatePicker
              selected={editedTrip.endDate}
              onChange={date => setEditedTrip({ ...editedTrip, endDate: date })}
              dateFormat="MMMM d, yyyy"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              minDate={editedTrip.startDate} // Restrict endDate to startDate or later
              className="edit-modal-input"
            />
          </div>
        </div>
        <div className="modal-actions">
          <button className="modal-action-button" onClick={onClose}>Cancel</button>
          <button className="modal-action-button" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditTripModal;